module.exports = __webpack_public_path__ + "static/sky-trust-1621f0c129b5fdeef31b0f2e196f9054.png";